// extracted by mini-css-extract-plugin
export default {"logoFooter":"Footer_logoFooter__AiGV2"};